import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/thumbs-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M466.3 225.3c8.8 14.9 13.7 30.7 13.7 49.8 0 44-37.2 85.6-85.8 85.6h-36.5c4.9 12.8 8.8 28.1 8.8 46.5 0 72.8-37.7 104.7-95.3 104.7-61.6 0-58.1-94.9-71.8-108.6-22.7-22.7-49.6-66.4-68.8-83.4h-7.1c-5.5 9.6-15.9 16-27.7 16h-64c-17.7 0-32-14.3-32-32v-240c0-17.7 14.3-32 32-32h64c8.1 0 15.5 3 21.2 8h10.8c41 0 73.2-40 176.8-40 7.2 0 15.2 0 22.2 0 77.1 0 112 39.4 112.9 95.3 13.3 18.4 20.3 43.1 17.3 67 9.9 18.5 13.7 40.3 9 63zM64 296c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM394.2 312.7c21.1 0 37.7-18.9 37.8-37.8 0.1-18.9-12.8-37.8-22.3-37.8 13.5-14.6 16.4-45.2-5.2-65.6 12.6-21.1 1.3-49.4-13.9-57.6 7.7-48.8-17.6-65.9-53.1-65.9h-37.8c-71.6 0-118 37.8-171.6 37.8v186.2h10.9c28.4 0 68 70.9 94.5 97.5 28.4 28.4 18.9 75.6 37.8 94.5 47.3 0 47.3-33 47.3-56.7 0-39.2-28.4-56.7-28.4-94.5h104z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/thumbs-down.js
// module id = 1824
// module chunks = 0